import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import { Message } from 'view-design'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    redirect: '/index',
    component: () =>
        import('@/views/layout/Layout'),
    children: [
        // 首页
        {
            path: '/index',
            name: 'index',
            component: () =>
                import('@/views/index/Index')
        },


        // 公开班级
        {
            path: '/openClass',
            name: 'openClass',
            component: () =>
                import('@/views/openClass/OpenClass')
        },

        // 公开班级详情
        {
            path: '/openClassDetail',
            name: 'openClassDetail',
            component: () =>
                import('@/views/openClass/OpenClassDetail')
        },
        {
            path: '/studyBox',
            name: 'studyBox',
            component: () =>
                import('@/views/study/studyBox')
        },
        // 资源包详情
        {
            path: '/pushBanner',
            name: 'pushBanner',
            component: () =>
                import('@/views/openClass/pushBanner')
        },
        // 我的班级
        {
            path: '/myClass',
            name: 'myClass',
            component: () =>
                import('@/views/myClass/MyClass')
        },
        // 培训资源
        {
            path: '/resource',
            name: 'resource',
            component: () =>
                import('@/views/resource/index'),
            meta: {

            }
        },
        // 公开课程
        {
            path: '/course',
            name: 'course',
            component: () =>
                import('@/views/course/Course')
        },
        // 个人中心
        {
            path: '/personal',
            name: 'personal',
            component: () =>
                import('@/views/personalCenter/Personal')
        },
        // 新闻资讯
        {
            path: '/newsInformation',
            name: 'newsInformation',
            component: () =>
                import('@/views/newsInformation/NewsInformation')
        },
        {
            path: '/notice',
            name: 'notice',
            component: () =>
                import('@/views/notice/index')
        },
        // 新闻资讯详情
        {
            path: '/newsInformationDetail',
            name: 'newsInformationDetail',
            component: () =>
                import('@/views/newsInformation/NewsInformationDetail')
        },
        // 专题专栏
        {
            path: '/mediaFocus',
            name: 'mediaFocus',
            component: () =>
                import('@/views/mediaFocus/MediaFocus')
        },
        {
            path: '/tianfuForum-aSharedLecture',
            name: 'tianfuForum-aSharedLecture',
            component: () =>
                import('@/views/tianfuForum-aSharedLecture/index')
        },


        {
            path: '/video-detail',
            name: 'video-detail',
            component: () =>
                import('@/views/video-detail')
        },
        {
            path: '/customer',
            name: 'customer',
            component: () =>
                import('@/components/customer')
        },


    ]
},
{
    path: '/specialColumn',
    component: () =>
        import('@/views/layout/Layout2'),
    children: [
        {
            path: 'index',
            name: 'SpecialColumnIndex',
            component: () =>
                import('@/views/specialColumn/index')
        },
        {
            path: 'course',
            name: 'specialColumnCourse',
            component: () =>
                import('@/views/specialColumn/course')
        },
        {
            path: 'courseware',
            name: 'specialColumnCourseware',
            component: () =>
                import('@/views/specialColumn/courseware')
        },
        {
            path: 'study',
            name: 'specialColumnCourStudy',
            component: () =>
                import('@/views/specialColumn/components/studyBox')
        },


    ],
},


{
    path: '/quickLogin',
    name: 'quickLogin',
    component: () =>
        import('@/views/login/quickLogin')
},



{
    path: '*',
    name: '404',
    component: () =>
        import('@/views/404/404')
}

]

// 需要动态添加的路由

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})
/* 共用外网登录*/
router.beforeEach((to, from, next) => {
    if (to.name == 'course' && !store.state.session.userId) {
        Message.warning("当前用户未登录，请登录。");
        next("/index");
        return;
    }
    next();
});
export default router